export default __webpack_public_path__ + "landlord-1-e43a92de2399ec8bde6a679b540a24d1.bundle.svg";